import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class DesignTheme extends AManagerApi {
    protected _url: string = '/site/theme';
}
